import { useMemo } from "react"

export type DeviceType = "mobile" | "tablet" | "desktop"

/** Кастомный хук по определению устройства */
export const useDeviceType = (): DeviceType => {
    return useMemo(() => {
        if (typeof window === "undefined") {
            // безопасный дефолт для SSR
            return "desktop"
        }

        const userAgent = navigator.userAgent

        if (/Tablet|iPad/i.test(userAgent)) return "tablet"
        if (/Mobi|Android/i.test(userAgent)) return "mobile"
        return "desktop"
    }, [])
}
